import { render, staticRenderFns } from "./storeManage.vue?vue&type=template&id=1926007b&scoped=true&"
import script from "./storeManage.vue?vue&type=script&lang=js&"
export * from "./storeManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1926007b",
  null
  
)

export default component.exports